
import { StyleColorSchemeType, StyleSizeType, StylePositionType } from '../../styles/enums';
import Icon from '../icon';
import Gutter from '../gutter';
import StyleClassNamesBuilder from '../../styles/helpers/StyleClassNamesBuilder';
import { IconType } from '../icon/enums';
import { CheckboxEventType, CheckboxProperty } from './enums';

export default {
  name: 'Checkbox',
  components: {
    Gutter,
    Icon,
  },
  props: {
    [CheckboxProperty.Value]: {
      default: '',
      type: [String, Number, Object, Boolean],
    },
    [CheckboxProperty.Label]: {
      default: '',
      type: String,
    },
    [CheckboxProperty.Disabled]: {
      default: false,
      type: Boolean,
    },
    [CheckboxProperty.Id]: {
      default: '',
      type: String,
    },
    [CheckboxProperty.IsChecked]: {
      default: false,
      type: Boolean,
    },
    [CheckboxProperty.ClassName]: {
      default: '',
      type: String,
    },
    [CheckboxProperty.CheckboxIconSize]: {
      default: StyleSizeType.Medium,
      type: String,
    },
  },
  data() {
    return {
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      IconType,
      CheckboxProperty,
    };
  },
  computed: {
    checkboxClassnames() {
      return new StyleClassNamesBuilder('checkbox')
        .addClassName(this[CheckboxProperty.ClassName])
        .build();
    },
    checkboxWrapperClassNames() {
      return new StyleClassNamesBuilder('checkbox-input-wrapper')
        .addConditionClassName('checked', this[CheckboxProperty.IsChecked])
        .addConditionClassName('disabled', this[CheckboxProperty.Disabled])
        .build();
    },
    inputChecked() {
      return this[CheckboxProperty.IsChecked];
    },
  },
  methods: {
    handleClick(event) {
      event.preventDefault();
      this.$emit(CheckboxEventType.Toggle, this[CheckboxProperty.Value]);
    },
  },
};
